import { Page } from "../components/_partials";
import { useParams } from "react-router-dom";
import { useData } from "../hooks/useData";
import { DataStatut } from "../enums/DataStatut";
import { Trophies } from "../components/_partials/Menu";
import HeadTrophyPage from "../components/_partials/HeadTrophyPage"
import NotFound from "../components/NotFound";
import ListTrophyRoad from "../components/Project/ListTrophyRoad";

export default function ProjectTrophy () {
  const { title } = useParams();
  const { isLoading, error, getProjects } = useData();

  if (isLoading) return <div>🔄 Chargement...</div>;
  if (error) return <div>❌ Erreur: {error}</div>;

  const project = getProjects({
    where: { title: title, statut: DataStatut.ACTIF },
  })[0];

  if (!project) return <NotFound></NotFound>;

  return (
    <Page>
      <HeadTrophyPage project={project}></HeadTrophyPage>
      <main>
        {project.trophyRoads.length <= 1 
        ? (
          <ListTrophyRoad road={project.trophyRoads[0]}>
          </ListTrophyRoad>
        )
        : (
          <>
            {project.trophyRoads.map((road) => {
              return (
                <Trophies type="road" project={project} road={road}></Trophies>
              );
            })}
          </>
        )}
      </main>
    </Page>
  );
}